import { useEffect, useRef } from 'react';
import { useCountUp, replayClass } from '../../lib/motion';

/** #8 Precio que cuenta hasta el valor nuevo, con un pulso de color. El valor final se anuncia (aria-live). */
export default function AnimatedPrice({ value, prefix = '$', suffix = '', className = '', live = true }) {
  const shown = useCountUp(Number(value) || 0);
  const ref = useRef(null);
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    replayClass(ref.current, 't-pulse-text');
  }, [value]);
  return (
    <span className={`tabular inline-block ${className}`} ref={ref}>
      <span aria-hidden="true">
        {prefix}
        {Math.round(shown).toLocaleString('es-MX')}
        {suffix}
      </span>
      <span className="sr-only" aria-live={live ? 'polite' : undefined}>
        {prefix}
        {Math.round(Number(value) || 0)}
        {suffix}
      </span>
    </span>
  );
}
